import isoCountries from 'i18n-iso-countries'
// eslint-disable-next-line @typescript-eslint/no-var-requires
isoCountries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
// eslint-disable-next-line @typescript-eslint/no-var-requires
isoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'))

const northIreland = ['ZZ', 'Irlande du Nord'] as [string, string]

const countries = Object.entries(isoCountries.getNames('fr')).concat([northIreland])
// const countriesEn = Object.entries(isoCountries.getNames('en')).concat([northIreland])

export function getCountryLabel(key?: string, lang = 'fr'): string | undefined {
  Object.entries(isoCountries.getNames(lang)).concat([northIreland])
  if (key === undefined) {
    return undefined
  } else if (key === 'ZZ') {
    return lang === 'fr' ? 'Irlande du Nord' : 'North Irland'
  }
  return isoCountries.getName(key, lang)
}
export default countries
